import { render, staticRenderFns } from "./materia_manage.vue?vue&type=template&id=4be05aee&scoped=true"
import script from "./materia_manage.vue?vue&type=script&lang=ts"
export * from "./materia_manage.vue?vue&type=script&lang=ts"
import style0 from "./materia_manage.vue?vue&type=style&index=0&id=4be05aee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4be05aee",
  null
  
)

export default component.exports